export default "/institutions/ton.svg";